import { render, staticRenderFns } from "./PurchaseListFilters.vue?vue&type=template&id=0f267b58&"
import script from "./PurchaseListFilters.vue?vue&type=script&lang=js&"
export * from "./PurchaseListFilters.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports